import React from 'react';

import { compose } from 'redux';
import { connect } from 'react-redux';
import { propTypes } from '../../util/types';
import {
  Footer,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
} from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';

import { FormattedMessage, injectIntl } from 'react-intl';

import background from '../../assets/bannerImg.png';
// import receptionist from '../../assets/svg/Socialresponsibility.svg';
// import HandShake from '../../assets/svg/Collaborate.svg';
// import Bulb from '../../assets/svg/Needs.svg';
// import earthOnHand from '../../assets/svg/openidea.svg';
// import Flexible from '../../assets/svg/Responsibility.svg';
import sosOwner from '../../assets/jean.png';
import sosOwnerSeb from '../../assets/sebastien.png';

// import riskFree from '../../assets/svg/Dataintegrity.svg';
import { ReactComponent as RocketIcon } from '../../assets/svg/rocket.svg';
import { ReactComponent as HandIcon } from '../../assets/svg/hand.svg';
import { ReactComponent as RecycleIcon } from '../../assets/svg/recycle.svg';
import { ReactComponent as CircleHandIcon } from '../../assets/svg/Responsibility.svg';
import { ReactComponent as EarthHandIcon } from '../../assets/svg/earthHand.svg';
import { ReactComponent as ShieldIcon } from '../../assets/svg/shield.svg';




import config from '../../config';
import { withRouter } from 'react-router-dom';
import css from './AboutSos.module.css';
import classNames from 'classnames';

const AboutSos = props => {
  const { scrollingDisabled, intl, isAuthenticated } = props;
  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'LandingPage.schemaTitle' }, { siteTitle });

  return (
    <Page
      title={schemaTitle}
      scrollingDisabled={scrollingDisabled}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: schemaTitle,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          {/* <TopbarContainer className={topbarClasses} /> */}
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain>
          <div className={css.herosection}>
            <img src={background} alt="coverImg" />
            {/* <div className={css.HeroContentMain}> */}
            <div className={css.heroComponent}>
              <p className={css.herotext}>
                <FormattedMessage id="AboutUs.sosStory" />{' '}
                <FormattedMessage id="AboutUs.sosSecondStory" />
              </p>
              <p className={classNames(css.herotext, css.lowerText)}>
                <FormattedMessage id="AboutUs.lowerStory" />{' '}
                <FormattedMessage id="AboutUs.lowerSecondStory" />
              </p>
            </div>
            {/* </div> */}
          </div>
          <div className={css.outerAboutUsDiv}>
            <div className={css.AboutUsDivWrap}>
              <div className={css.howItBeginDiv}>
                <div className={css.AboutInfo}>
                  <p className={css.heading}>
                    {' '}
                    <FormattedMessage id="AboutUs.howItBeginDivTitle" />{' '}
                  </p>

                  <div>
                    <p className={css.paraText}>
                      <FormattedMessage id="AboutUs.sosStaffValuesPara1" />{' '}
                    </p>

                    {/* <p className={css.paraText}>
                      <FormattedMessage id="AboutUs.sosStaffValuesPara2" />{' '}
                    </p>

                    <p className={css.paraText}>
                      <FormattedMessage id="AboutUs.sosStaffValuesPara3" />{' '}
                    </p>

                    <p className={css.paraText}>
                      <FormattedMessage id="AboutUs.sosStaffValuesPara4" />{' '}
                    </p> */}
                  </div>
                </div>
                <div className={css.AboutInfo}>
                  <p className={css.heading}>
                    {' '}
                    <FormattedMessage id="AboutUs.SOSStaffMission" />{' '}
                  </p>

                  <div>
                    <p className={css.paraText}>
                      <FormattedMessage id="AboutUs.sosStaffMissionPara1" />{' '}
                    </p>
                  </div>
                </div>
                {/* <div className={css.imgDiv}><img src={sosOwner} alt="coverImg" /></div> */}
                {/* <p className={css.mobileheading}>
                  <FormattedMessage id="AboutUs.howItBeginDivTitle" />{' '}
                </p> */}
              </div>
            </div>
            {/* <div className={css.AboutUsDivWrap}>
              <div className={css.sosMissionDiv}>
                <p className={css.heading}>
                  {' '}
                  <FormattedMessage id="AboutUs.SOSStaffMission" />{' '}
                </p>

                <p className={css.paraText}>
                  <FormattedMessage id="AboutUs.sosStaffMissionPara1" />{' '}
                </p>
              </div>
            </div> */}
            <div className={css.AboutUsDivWrap}>
              <div className={css.WhySosOwnerMain}>
                <p className={css.heading}>
                  {' '}
                  <FormattedMessage id="AboutUs.sosStaffValues" />{' '}
                </p>
                <div className={css.staffValueContainer}>
                  <div className={css.boxItem}>
                    <div className={css.icondiv}>
                     <RocketIcon/>
                    </div>
                    <div className={css.boxItemDescContainer}>
                      <h3 className={css.title}>
                        {' '}
                        <FormattedMessage id="AboutUs.Innovation" />{' '}
                      </h3>
                      <p className={css.about}>
                        <FormattedMessage id="AboutUs.InnovationAbout" />
                      </p>
                    </div>
                  </div>
                  <div className={css.boxItem}>
                    <div className={css.icondiv}>
                      {' '}
                      <HandIcon/>
                    </div>
                    <div className={css.boxItemDescContainer}>
                      <h3 className={css.title}>
                        <FormattedMessage id="AboutUs.Collaboration" />{' '}
                      </h3>
                      <p className={css.about}>
                        {' '}
                        <FormattedMessage id="AboutUs.collaborationAbout" />{' '}
                      </p>
                    </div>
                  </div>
                  <div className={css.boxItem}>
                    <div className={css.icondiv}>
                      <RecycleIcon/>
                    </div>
                    <div className={css.boxItemDescContainer}>
                      <h3 className={css.title}>
                        <FormattedMessage id="AboutUs.SocialResponsibility" />
                      </h3>
                      <p className={css.about}>
                        <FormattedMessage id="AboutUs.SocialResponsibilityAbout" />{' '}
                      </p>
                    </div>
                  </div>

                  <div className={css.boxItem}>
                    <div className={css.icondiv}>
                      {' '}
                      <CircleHandIcon/>
                    </div>
                    <div className={css.boxItemDescContainer}>
                      <h3 className={css.title}>
                        <FormattedMessage id="AboutUs.Flexibility" />
                      </h3>
                      <p className={css.about}>
                        {' '}
                        <FormattedMessage id="AboutUs.FlexibilityAbout" />
                      </p>
                    </div>
                  </div>
                  <div className={css.boxItem}>
                    <div className={css.icondiv}>
                      {' '}
                       <EarthHandIcon/>
                      {/* <img src={receptionist} alt="receptionist" />{' '} */}
                    </div>
                    <div className={css.boxItemDescContainer}>
                      <h3 className={css.title}>
                        <FormattedMessage id="AboutUs.CustomerService" />
                      </h3>
                      <p className={css.about}>
                        {' '}
                        <FormattedMessage id="AboutUs.CustomerServiceAbout" />{' '}
                      </p>
                    </div>
                  </div>
                  <div className={css.boxItem}>
                    <div className={css.icondiv}>
                      {' '}
                      <ShieldIcon/>
                      {/* <img src={riskFree} alt="receptionist" />{' '} */}
                    </div>
                    <div className={css.boxItemDescContainer}>
                      <h3 className={css.title}>
                        <FormattedMessage id="AboutUs.Confidentiality" />
                      </h3>
                      <p className={css.about}>
                        {' '}
                        <FormattedMessage id="AboutUs.ConfidentialityAbout" />{' '}
                      </p>
                    </div>
                  </div>
                  <div className={css.AboutUsDivWrap}>
                    <div className={css.sosMissionDiv}>
                      <p className={css.heading}>
                        {' '}
                        <FormattedMessage id="AboutUs.foundersHeading" />{' '}
                      </p>

                      <p className={css.paraText}>
                        <FormattedMessage id="AboutUs.foundersHeadingPara1" />{' '}
                      </p>
                      <div className={css.founderBackgroundColour}>
                        <div className={css.jeanFounder}>
                          <div className={css.imgDiv}>
                            <img src={sosOwner} alt="coverImg" />
                          </div>
                          <div className={css.founderText}>
                            <p className={classNames(css.paraText, css.jeanPara)}>
                              <FormattedMessage id="AboutUs.foundersHeadingPara2" />
                            </p>
                          </div>
                        </div>
                        <div className={css.jeanFounder}>
                        <div className={css.imgDiv}>
                            <img src={sosOwnerSeb} alt="coverImg" />
                          </div>
                          <div className={css.founderText}>
                            <p className={css.paraText}>
                              <FormattedMessage id="AboutUs.foundersHeadingPara3" />
                            </p>
                          </div>

                        </div>
                    </div>
                     <div className={css.bottomDiv}>
                       <p className={css.paraText}>
                        <FormattedMessage id="AboutUs.foundersHeadingPara4" />{' '}
                       </p>
                      </div>
                    </div>
                  </div>

                  <div className={classNames(css.AboutUsDivWrap,css.AboutUsDivNew)}>
                    <div className={css.howItBeginDiv}>
                      <div className={css.AboutInfo}>
                        <p className={css.heading}>
                          {' '}
                          <FormattedMessage id="AboutUs.commitmentHeading" />{' '}
                        </p>

                        <div>
                          <p className={css.paraText}>
                            <FormattedMessage id="AboutUs.commitmentPara1" />{' '}
                          </p>
                        </div>
                      </div>
                      <div className={css.AboutInfo}>
                        <p className={css.heading}>
                          {' '}
                          <FormattedMessage id="AboutUs.RevolutionHeading" />{' '}
                        </p>

                        <div>
                          <p className={css.paraText}>
                            <FormattedMessage id="AboutUs.RevolutionPara1" />{' '}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  const { isAuthenticated } = state.Auth;

  return {
    isAuthenticated,
  };
};

export default compose(
  injectIntl,
  withRouter,
  connect(mapStateToProps)
)(AboutSos);
